export enum handlerType {
  SAVE = 'save',
  EDIT = 'edit'
}
